export default "__VITE_ASSET__CevIZT0Y__"